var jobhajApplication = {
	bindings: {},
	/**
     * @ngInject
     */
	controller: function JobhajApplicationCtrl($scope, $route, $timeout, $sce, $auth, flux, actions, userStore, $location){
		var ctrl = this;
		var size;
		ctrl.messages = {
			intro: [],
			motivation: [],
			login: [],
			look: [],
			experience: [],
			jobMap: []
		};
		// objects to show job experiences in overview card.
        ctrl.jobPlaceholders = [];
        // defines if user has chosen an experience (chosen No or some value)
        ctrl.isExperienceSubmitted;

		function init(){
            ctrl.user = userStore.getUser();

			// update "complete" class for "experience" block on main application page
            // it controls "+" button on this block as well
            checkExperienceSubmitted();
		}

		function link(){
			var size = 0;
			if(ctrl.user.photo) {
				size++;
			}
			if(ctrl.user.email && ctrl.user.phone && ctrl.user.birthday && ctrl.user.name) {
				size++;
			}
			if(ctrl.user.smilies) {
				size++;
			}
			if(ctrl.user.motivation) {
				size++;
			}
			if(ctrl.user.interests) {
				size++;
			}
			if(ctrl.user.experience) {
				size++;
			}
			if(ctrl.user.languages) {
				size++;
			}
			if(ctrl.user.workhours) {
				size++;
			}
			if(ctrl.user.look) {
				size++;
			}

            // Messages which runs on init() by default always
			$timeout(function() {
			    ctrl.addMsg({
			        content: $sce.trustAsHtml('Jo mere du udfylder din ansøgning, jo bedre bliver din ansøgning 🤓'),
			        type: 'receive'
			    }, 'motivation');

			    ctrl.addMsg({
			        content: $sce.trustAsHtml('Hvis du allerede har en Jobhaj-bruger, så husk at logge ind oppe i menuen 🤓'),
			        type: 'receive'
			    }, 'login');

			    ctrl.addMsg({
			        content: $sce.trustAsHtml('Har du haft et fritidsjob før, så tilføj det her 👌'),
			        type: 'receive'
			    }, 'experience');
			}, 500);
            $timeout(function() {
                ctrl.addMsg({
                    content: $sce.trustAsHtml('Her kan du finde ledige job i nærheden af dig. Tryk på knappen for at se mere 😊'),
                    type: 'receive'
                }, 'jobMap');
            }, 2500);


			// Messages which runs on init() depending on size - how many steps have user have passed?
			if(!size) {
				$timeout(function() {
					ctrl.addMsg({
				        content: $sce.trustAsHtml('Hej! 👋 Her kan vi lave din ansøgning sammen 😊'),
				        type: 'receive'
				    }, 'intro');
				}, 500);
			} else {
				$timeout(function() {
					ctrl.addMsg({
				        content: $sce.trustAsHtml('Hej! 👋 Godt klaret! Du har udfyldt '+size+' ud af 9 trin 😇'),
				        type: 'receive'
				    }, 'intro');
				}, 500);
			}

			// "Look" section messages
			if(angular.isUndefined(ctrl.user.look)) {
				$timeout(function() {
					ctrl.addMsg({
				        content: $sce.trustAsHtml('💅 Til sidst kan du vælge udseendet til din ansøgning'),
				        type: 'receive'
				    }, 'look');
				}, 500);
			} else {
				$timeout(function() {
					if($auth.isAuthenticated()) {
						ctrl.addMsg({
					        content: $sce.trustAsHtml('Wow! Godt klaret! 👏 Det bliver en flot ansøgning'),
					        type: 'receive'
					    }, 'look');
					} else {
						ctrl.addMsg({
					        content: $sce.trustAsHtml('Wow! Godt klaret! 👏 Husk at gemme din ansøgning'),
					        type: 'receive'
					    }, 'look');
					}
					
				}, 500);
			}
		}

		// update scope user, when user in store is updated
		function onUserUpdated() {
			ctrl.user = userStore.getUser();

            // fill up previous experiences
            getUserExperiences();

            // update "complete" class for experience block
			// it controls "+" button on this block as well.
            checkExperienceSubmitted();
 		}

 		// function to fill up object ctrl.jobPlaceholders
 		function getUserExperiences() {
            var userExperience = ctrl.user.experience;
            ctrl.jobPlaceholders = [];

            for (var i = 0; i < 3; i++) {
                // if item in array is not "undefined", we add this item to array, otherwise add empty object
                if (userExperience !== undefined && userExperience !== 'none' && userExperience[i]) {
                    ctrl.jobPlaceholders.push(
                        {
                            id: userExperience[i].id,
                            jobTitle: userExperience[i].jobTitle,
                        }
                    );
                } else {
                    ctrl.jobPlaceholders.push(
                        {
                            id: null,
                            jobTitle: 'Tilføj joberfaring'
                        }
                    );
                }
            }
        }

        // function to update isExperienceSubmitted variable, which is responsible for "+" btn and "complete" class
		// state on experience block
        function checkExperienceSubmitted() {
			// reset value on each check
			ctrl.isExperienceSubmitted = false;

            var userExperience = ctrl.user.experience;
            if ( Array.isArray(userExperience) && userExperience.length !== 0 ) {
				ctrl.isExperienceSubmitted = true;
            }
            if (userExperience === "none") {
				ctrl.isExperienceSubmitted = true;
            }
        }

 		// default Angular life circle hooks
		ctrl.$onInit = init;
		ctrl.$postLink = link;

		// remove job experience from ctrl.user.experience array by its Id
		ctrl.removeJobExperience = function (expId) {
            var formData = {};

            // remove item by id from ctrl.user.experience array
            _.remove(ctrl.user.experience, function(e) { return e.id == expId; });

            // update formData object
            formData.experience = ctrl.user.experience;

            // save user data with UPDATE_USER action, which expects formData object.
            flux.dispatch(actions.UPDATE_USER, formData);

            // redirect to main application page
            $location.path( "/din-ansoegning#!" );
        };

		ctrl.addMsg = function addMsg(message, arrayName) {
		    message = {
		        content: message.content,
		        type: message.type
		    };
		    ctrl.messages[arrayName].push(message);
		};

		$scope.$listenTo(userStore, ['user'], onUserUpdated);
	},
	templateUrl: './angular/components/jobhaj-application.component.html'
};